import { createSlice } from "@reduxjs/toolkit";
import {
  getRentalReport,
  getSaleReport,
  getRevenueReport,
  getGuestReport,
  getGuestReportSale,
  getResultsAssetType,
  getSaleRevenueReport,
} from "../../API/ReportAPI";

const initialState = {
  Rental: [],
  Sale: [],
  Revenue: [],
  SaleRevenue: [],
  GuestRent: [],
  GuestSale: [],
  ResultsAssetType: [],
};

export const ReportSlice = createSlice({
  name: "ReportState",
  initialState,
  reducers: {
    updateGetRentalReport: (state, action) => {
      state.Rental = action.payload;
    },
    updateGetSaleReport: (state, action) => {
      state.Sale = action.payload;
    },
    updateGetRevenueReport: (state, action) => {
      state.Revenue = action.payload;
    },
    updateGetGuestReport: (state, action) => {
      state.GuestRent = action.payload;
    },
    updateGetGuestReportSale: (state, action) => {
      state.GuestSale = action.payload;
    },
    updateGetResultsAssetType: (state, action) => {
      state.ResultsAssetType = action.payload;
    },
    updateGetSaleRevenueReport: (state, action) => {
      state.SaleRevenue = action.payload;
    },
  },
});

export const { updateGetRentalReport } = ReportSlice.actions;
export const getRentalReportDetail = (value) => async (dispatch) => {
  await getRentalReport(value).then(async (data) => {
    await dispatch(updateGetRentalReport(data));
  });
};

export const { updateGetSaleReport } = ReportSlice.actions;
export const getSaleReportDetail = (value) => async (dispatch) => {
  await getSaleReport(value).then(async (data) => {
    await dispatch(updateGetSaleReport(data));
  });
};

export const { updateGetRevenueReport } = ReportSlice.actions;
export const getRevenueReportDetail = (value) => async (dispatch) => {
  await getRevenueReport(value).then(async (data) => {
    await dispatch(updateGetRevenueReport(data));
  });
};

export const { updateGetGuestReport } = ReportSlice.actions;
export const getGuestReportDetail = (value) => async (dispatch) => {
  await getGuestReport(value).then(async (data) => {
    await dispatch(updateGetGuestReport(data));
  });
};

export const { updateGetGuestReportSale } = ReportSlice.actions;
export const getGuestReportSaleDetail = (value) => async (dispatch) => {
  await getGuestReportSale(value).then(async (data) => {
    await dispatch(updateGetGuestReportSale(data));
  });
};

export const { updateGetResultsAssetType } = ReportSlice.actions;
export const getResultsAssetTypeDetail = (value) => async (dispatch) => {
  await getResultsAssetType(value).then(async (data) => {
    await dispatch(updateGetResultsAssetType(data));
  });
};

export const { updateGetSaleRevenueReport } = ReportSlice.actions;
export const getSaleRevenueReportDetail = (value) => async (dispatch) => {
  await getSaleRevenueReport(value).then(async (data) => {
    await dispatch(updateGetSaleRevenueReport(data));
  });
};

export default ReportSlice.reducer;
